<template>
  <div class="page-item">
    <base-section-title class="m-l-24 m-b-8" title="进行中的项目" />
    <nav-bar :list="dataList" @handleSelect="handleSelect" />
    <el-scrollbar v-if="current.data && current.data.length">
      <div class="content">
        <div
          v-for="(item, index) in current.data"
          :key="index"
          class="list-item"
          @click="detailView(current, item)"
        >
          <div class="item1">
            <div class="name-box">
              <span class="name text-ellipsis">
                {{ item[current.titleName] }}
              </span>
              <span v-if="item.isKpbProject" class="text2 m-l-6">电子化</span>
            </div>
            <span
              class="text3"
              :class="
                current.dictionaryText
                  ? ''
                  : current.dictionary.translate(item[current.dictionaryStatus])
                    .type
              "
            >
              <span v-if="current.dictionaryText">
                {{ current.dictionaryText }}
              </span>
              <span v-else>
                <span
                  v-if="
                    item.purchaseType ===
                      purchaseAllTypeDict.NEGOTIATION_V2.value &&
                      item.negotiateType == negotiateTypeDict.COMMON.value
                  "
                >
                  {{
                    current.dictionary.translate(item[current.dictionaryStatus])
                      .commonLabel
                  }}
                </span>
                <span v-else>
                  {{
                    current.dictionary.translate(item[current.dictionaryStatus])
                      .label || '-'
                  }}
                </span>
              </span>
            </span>
          </div>
          <div
            v-if="
              item.purchaseType === purchaseAllTypeDict.NEGOTIATION_V2.value &&
                item.negotiateType == negotiateTypeDict.V2.value
            "
            class="item2"
          >
            <div
              v-for="(optionItem, optionIndex) in current.options2"
              :key="optionIndex"
              class="text1 text-ellipsis"
              :class="[
                optionIndex % 2 == 1 ? 'text2' : '',
                optionItem.col ? 'text3' : ''
              ]"
            >
              <span v-if="optionItem.filter">
                <span v-if="optionItem.filter == 'province'">
                  {{ optionItem.label }}{{ item.province }} / {{ item.city }} /
                  {{ item.area }}
                </span>
                <span v-else>
                  {{ optionItem.label }}
                  {{ optionItem.filter(item[optionItem.prop]) }}
                </span>
              </span>
              <span v-else>
                {{ optionItem.label }}
                <span v-if="optionItem.currency">
                  {{ optionItem.currency }}
                </span>
                {{ item[optionItem.prop] || '-' }}
                <span v-if="optionItem.unit">
                  {{ optionItem.unit }}
                </span>
              </span>
            </div>
          </div>
          <div v-else class="item2">
            <div
              v-for="(optionItem, optionIndex) in current.options"
              :key="optionIndex"
              class="text1 text-ellipsis"
              :class="[
                optionIndex % 2 == 1 ? 'text2' : '',
                optionItem.col ? 'text3' : ''
              ]"
            >
              <span v-if="optionItem.filter">
                <span v-if="optionItem.filter == 'province'">
                  {{ optionItem.label }}{{ item.province }} / {{ item.city }} /
                  {{ item.area }}
                </span>
                <span v-else>
                  {{ optionItem.label }}
                  {{ optionItem.filter(item[optionItem.prop]) }}
                </span>
              </span>
              <span v-else>
                {{ optionItem.label }}
                {{ item[optionItem.prop] || '-' }}
                <span v-if="optionItem.unit">
                  {{ optionItem.unit }}
                </span>
              </span>
            </div>
          </div>
          <div v-if="current.bottomOptions" class="item2">
            <div
              v-for="(bottomOptionItem,
                      bottomOptionIndex) in current.bottomOptions"
              :key="bottomOptionIndex"
              class="text1 text4 text-ellipsis"
              :class="[
                bottomOptionIndex % 2 == 1 ? 'text2' : '',
                bottomOptionIndex.col ? 'text3' : ''
              ]"
            >
              <span v-if="bottomOptionItem.filter">
                <span v-if="item.purchaseCompanyName != item.ownerCompanyName">
                  {{ bottomOptionItem.label }}
                  {{ item[bottomOptionItem.prop] || '-' }}
                </span>
              </span>
              <span v-else>
                {{ bottomOptionItem.label }}
                {{ item[bottomOptionItem.prop] || '-' }}
              </span>
            </div>
          </div>
          <div
            class="list-line"
            :class="index == current.data.length - 1 ? 'no-list-line' : ''"
          ></div>
        </div>
        <div
          v-if="current.total > 5 && isIdentity == 'supplier'"
          class="hint-box m-t-16"
          @click="goList(current.linkName)"
        >
          此处仅展示5条进行中的项目数据，点击可查看更多
        </div>
        <div
          v-if="
            current.total > 6 &&
              (isIdentity == 'purchaser' || isIdentity == 'agency')
          "
          class="hint-box m-t-16"
          @click="goList(current.linkName)"
        >
          此处仅展示6条进行中的项目数据，点击可查看更多
        </div>
      </div>
    </el-scrollbar>
    <el-empty
      v-if="!current.total"
      description="暂无数据"
      :image="noData"
      class="content m-t-24"
    />
  </div>
</template>

<script>
import BaseSectionTitle from '@/components/common/BaseSectionTitle'
import NavBar from '@/views/home/components/NavBar'
import {
  inquiryFlowStatusDict,
  inquiryCompareWayDict,
  inquiryWayDict
} from '@/dictionary/project/inquiry'
import {
  competeStatusDict,
  competeTypeDict,
  competeMethodDict
} from '@/dictionary/project/compete'
import {
  negotiationV2TypeDict,
  negotiationV2StatusDict,
  negotiateTypeDict
} from '@/dictionary/project/negotiation-v2'
import { purchaseAllTypeDict, offerTypeDict } from '@/dictionary/project/common'

import {
  bidInviteBidStatusDict,
  bidPublishAuctionDict,
  efficientBidInviteWayDict,
  bidEntrustStatusDict
} from '@/dictionary/project/bid'
import { workbenchServiceDict } from '@/dictionary/system'

import {
  getBiddingOrdersPageApi,
  getInquireOrdersPageApi,
  getCompetitionOrdersPageApi,
  getRecruitOrdersPageApi,
  getNegotiationOrdersPageApi
} from '@/api/supplier/home'
import {
  getInquiryOrdersApi,
  getBiddingOrdersApi,
  getEntrustProjectsApi,
  getCompetitionOrdersApi,
  getNegotiateOrdersApi
} from '@/api/procure/home'
import { mapState } from 'vuex'

export default {
  name: 'HomeProject',

  components: {
    BaseSectionTitle,
    NavBar
  },

  data() {
    return {
      bidPublishAuctionDict,
      bidInviteBidStatusDict,
      purchaseAllTypeDict,
      negotiateTypeDict,
      workbenchServiceDict,

      noData: require('@/assets/images/home/Project-no-data.png'),
      purchaser: [
        {
          navTitle: '招标',
          titleName: 'orderName',
          data: [],
          dictionary: bidInviteBidStatusDict,
          dictionaryStatus: 'status',
          routerObj: 'tender-customize',
          linkName: 'BiddingList',
          api: getBiddingOrdersApi,
          params: {
            size: 6,
            identity: 'purchaser'
          },
          options: [
            {
              label: '招标方式：',
              prop: 'bidMethod',
              filter: value =>
                efficientBidInviteWayDict.translate(value).label || '-'
            },
            {
              label: '报价方式：',
              prop: 'offerType',
              filter: value => offerTypeDict.translate(value).label || '-'
            },
            {
              label: '招标估算：',
              prop: 'budget',
              currency: '￥',
              unit: '万元'
            },
            {
              label: '开标时间：',
              prop: 'openTime'
            }
          ],
          total: 0
        },
        {
          navTitle: '询比',
          titleName: 'orderName',
          data: [],
          dictionary: inquiryFlowStatusDict,
          dictionaryStatus: 'orderStatus',
          routerObj: 'inquiry-customize',
          linkName: 'InquiryList',
          api: getInquiryOrdersApi,
          params: {
            size: 6,
            identity: 'purchaser'
          },
          options: [
            {
              label: '询比方式：',
              prop: 'inquiryType',
              filter: value => inquiryWayDict.translate(value).label || '-'
            },
            {
              label: '比价方式：',
              prop: 'compareType',
              filter: value =>
                inquiryCompareWayDict.translate(value).label || '-'
            },
            {
              label: '报价截止时间：',
              prop: 'offerEndTime'
            }
          ],
          total: 0
        },
        {
          navTitle: '竞价',
          titleName: 'orderName',
          data: [],
          dictionary: competeStatusDict,
          dictionaryStatus: 'status',
          routerObj: 'compete-customize',
          linkName: 'CompeteManage',
          api: getCompetitionOrdersApi,
          params: {
            size: 6,
            identity: 'purchaser'
          },
          options: [
            {
              label: '竞价类型：',
              prop: 'competitionType',
              filter: value => competeTypeDict.translate(value).label || '-'
            },
            {
              label: '竞价方式：',
              prop: 'competitionMethod',
              filter: value => competeMethodDict.translate(value).label || '-'
            },
            {
              label: '报名截止时间：',
              prop: 'signUpEndTime'
            },
            {
              label: '竞价开始时间：',
              prop: 'competitionStartTime'
            }
          ],
          total: 0
        },
        {
          navTitle: '谈判', // 包含谈判和分项谈判
          titleName: 'orderName',
          data: [],
          dictionary: negotiationV2StatusDict,
          dictionaryStatus: 'orderStatus',
          routerObj: 'negotiate-customize',
          linkName: 'NegotiationList',
          api: getNegotiateOrdersApi,
          params: {
            size: 6,
            identity: 'purchaser'
          },
          options: [
            {
              label: '竞争方式：',
              prop: 'competeType',
              filter: value =>
                negotiationV2TypeDict.translate(value).label || '-'
            },
            {
              label: '谈判采购预算：',
              prop: 'budgetAmount',
              unit: '万元'
            },
            {
              label: '报名截止时间：',
              prop: 'applyEndTime'
            },
            {
              label: '文件响应截止时间：',
              prop: 'negotiateEndTime'
            }
          ],
          options2: [
            // 分项谈判
            {
              label: '竞争方式：',
              prop: 'competeType',
              filter: value =>
                negotiationV2TypeDict.translate(value).label || '-'
            },
            {
              label: '谈判采购预算：',
              prop: 'budgetAmount',
              unit: '万元'
            },
            {
              label: '报价截止时间：',
              prop: 'applyEndTime'
            },
            {
              label: '谈判时间：',
              prop: 'negotiateEndTime'
            }
          ],
          total: 0
        },
        {
          navTitle: '项目委托',
          titleName: 'projectName',
          data: [],
          dictionary: bidEntrustStatusDict,
          dictionaryStatus: 'acceptStatus',
          routerObj: 'entrustList-customize',
          linkName: 'PurchaserEntrustList',
          api: getEntrustProjectsApi,
          params: {
            size: 6,
            identity: 'purchaser'
          },
          options: [
            {
              label: '项目预算：',
              prop: 'budget',
              unit: '万元'
            },
            {
              label: '代理机构：',
              prop: 'agentCompanyName'
            },
            {
              label: '项目地点：',
              prop: 'province',
              filter: 'province'
            },
            {
              label: '详细地址：',
              prop: 'address'
            }
          ],
          total: 0
        }
      ],
      supplier: [
        {
          navTitle: '招标',
          titleName: 'orderName',
          data: [],
          dictionaryText: '进行中',
          routerObj: {
            name: 'SupplierPurchaseSignUp',
            params: {
              orderId: '',
              tradeId: ''
            }
          },
          linkName: 'ParticipateBid',
          api: getBiddingOrdersPageApi,
          params: {
            processStatus: 1,
            page: 1,
            size: 5
          },
          options: [
            {
              label: '响应截止时间：',
              prop: 'signUpEndTime'
            },
            {
              label: '开标时间：',
              prop: 'openTime'
            },
            {
              label: '招标地点：',
              prop: 'province',
              filter: 'province'
            },
            {
              label: '详细地址：',
              prop: 'address'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            },
            {
              label: '代理单位：',
              prop: 'purchaseCompanyName',
              filter: 'purchaseCompanyName'
            }
          ],
          total: 0
        },
        {
          navTitle: '询比',
          titleName: 'orderName',
          data: [],
          dictionaryText: '进行中',
          routerObj: {
            name: 'SupplierInquiryTrade',
            params: {
              orderId: '',
              tradeId: ''
            }
          },
          linkName: 'ParticipateInquiry',
          api: getInquireOrdersPageApi,
          params: {
            processStatus: 1,
            page: 1,
            size: 5
          },
          options: [
            {
              label: '报价截止时间：',
              col: 1,
              prop: 'offerEndTime'
            },
            {
              label: '收货地点：',
              prop: 'province',
              filter: 'province'
            },
            {
              label: '详细地址：',
              prop: 'address'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            },
            {
              label: '代理单位：',
              prop: 'purchaseCompanyName',
              filter: 'purchaseCompanyName'
            }
          ],
          total: 0
        },
        {
          navTitle: '竞价',
          titleName: 'orderName',
          data: [],
          dictionaryText: '进行中',
          routerObj: {
            name: 'SupplierCompeteSignUp',
            params: {
              orderId: '',
              tradeId: ''
            }
          },
          linkName: 'ParticipateCompete',
          api: getCompetitionOrdersPageApi,
          params: {
            processStatus: 1,
            page: 1,
            size: 5
          },
          options: [
            {
              label: '响应截止时间：',
              prop: 'signUpEndTime'
            },
            {
              label: '竞价开始时间：',
              prop: 'competitionStartTime'
            },
            {
              label: '收货地点：',
              prop: 'province',
              filter: 'province'
            },
            {
              label: '详细地址：',
              prop: 'address'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            },
            {
              label: '代理单位：',
              prop: 'purchaseCompanyName',
              filter: 'purchaseCompanyName'
            }
          ],
          total: 0
        },
        {
          navTitle: '招募',
          titleName: 'orderName',
          data: [],
          dictionaryText: '应募中',
          routerObj: {
            name: 'SupplierRecruitTrade',
            params: {
              orderId: '',
              tradeId: ''
            }
          },
          linkName: 'ParticipateRecruit',
          api: getRecruitOrdersPageApi,
          params: {
            queryType: 1,
            page: 1,
            size: 5
          },
          options: [
            {
              label: '招募截止时间：',
              col: 1,
              prop: 'recruitEndTime'
            },
            {
              label: '招募地区：',
              col: 1,
              prop: 'province',
              filter: 'province'
            }
          ],
          bottomOptions: [
            {
              label: '招募单位：',
              prop: 'ownerCompanyName'
            }
          ],
          total: 0
        },
        {
          navTitle: '谈判',
          titleName: 'orderName',
          data: [],
          dictionaryText: '进行中',
          routerObj: 'supplier-negotiate-customize',
          linkName: 'ParticipateNegotiation',
          api: getNegotiationOrdersPageApi,
          params: {
            processStatus: 1,
            page: 1,
            size: 5
          },
          options: [
            {
              label: '报名截止时间：',
              prop: 'signUpEndTime'
            },
            {
              label: '文件响应截止时间：',
              prop: 'responseEndTime'
            },
            {
              label: '谈判地点：',
              prop: 'province',
              filter: 'province'
            },
            {
              label: '详细地址：',
              prop: 'address'
            }
          ],
          options2: [
            {
              label: '报名截止时间：',
              prop: 'signUpEndTime'
            },
            {
              label: '文件响应截止时间：',
              prop: 'responseEndTime'
            },
            {
              label: '谈判地点：',
              prop: 'province',
              filter: 'province'
            },
            {
              label: '详细地址：',
              prop: 'address'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            }
          ],
          total: 0
        }
      ],
      agency: [
        {
          navTitle: '招标',
          titleName: 'orderName',
          data: [],
          dictionary: bidInviteBidStatusDict,
          dictionaryStatus: 'status',
          routerObj: 'tender-customize',
          linkName: 'AgencyBiddingList',
          api: getBiddingOrdersApi,
          params: {
            size: 5,
            identity: 'agent'
          },
          options: [
            {
              label: '招标方式：',
              prop: 'bidMethod',
              filter: value =>
                efficientBidInviteWayDict.translate(value).label || '-'
            },
            {
              label: '报价方式：',
              prop: 'offerType',
              filter: value => offerTypeDict.translate(value).label || '-'
            },
            {
              label: '招标估算：',
              prop: 'budget',
              unit: '万元'
            },
            {
              label: '开标时间：',
              prop: 'openTime'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            }
          ],
          total: 0
        },
        {
          navTitle: '询比',
          titleName: 'orderName',
          data: [],
          dictionary: inquiryFlowStatusDict,
          dictionaryStatus: 'orderStatus',
          routerObj: 'inquiry-customize', // 跳转详情过于复杂，单独处理
          linkName: 'AgencyEntrustInquiryList',
          api: getInquiryOrdersApi,
          params: {
            size: 5,
            identity: 'agent'
          },
          options: [
            {
              label: '询比方式：',
              prop: 'inquiryType',
              filter: value => inquiryWayDict.translate(value).label || '-'
            },
            {
              label: '比价方式：',
              prop: 'compareType',
              filter: value =>
                inquiryCompareWayDict.translate(value).label || '-'
            },
            {
              label: '报价截止时间：',
              prop: 'offerEndTime'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            }
          ],
          total: 0
        },
        {
          navTitle: '竞价',
          titleName: 'orderName',
          data: [],
          dictionary: competeStatusDict,
          dictionaryStatus: 'status',
          routerObj: 'compete-customize', // 跳转详情过于复杂，单独处理
          linkName: 'AgencyEntrustCompeteList',
          api: getCompetitionOrdersApi,
          params: {
            size: 5,
            identity: 'agent'
          },
          options: [
            {
              label: '竞价类型：',
              prop: 'competitionType',
              filter: value => competeTypeDict.translate(value).label || '-'
            },
            {
              label: '竞价方式：',
              prop: 'competitionMethod',
              filter: value => competeMethodDict.translate(value).label || '-'
            },
            {
              label: '报名截止时间：',
              prop: 'signUpEndTime'
            },
            {
              label: '竞价开始时间：',
              prop: 'competitionStartTime'
            }
          ],
          bottomOptions: [
            {
              label: '采购单位：',
              prop: 'ownerCompanyName'
            }
          ],
          total: 0
        }
      ],
      dataList: [],
      index: 0,
      current: {}
    }
  },

  computed: {
    ...mapState('router', ['currentWorkbench']),

    // 代理机构加上Agency
    entrustRouter() {
      if (this.currentWorkbench === workbenchServiceDict.AGENCY.value) {
        return 'Agency'
      }
      return ''
    },
    // 获取当中工作台身份
    isIdentity() {
      return workbenchServiceDict.translate(this.currentWorkbench)?.alias
    }
  },

  watch: {
    currentWorkbench: {
      handler: function(val) {
        if (val) {
          this.index = 0
          this.getLIst()
        }
      },
      immediate: true
    }
  },

  created() {},

  mounted() {},

  methods: {
    getLIst() {
      this.dataList = this[this.isIdentity]
      this.dataList.map((item, index) => {
        item
          .api(item.params)
          .then(res => {
            item.data = res.data.records || []
            item.total = res.data.total
            if (!index) {
              this.current = item
            }
          })
          .catch(err => {
            this.$message.error(err?.message || err)
          })
      })
    },
    handleSelect(key, keyPath) {
      this.index = Number(key)
      this.current = this.dataList[this.index]
    },
    // 查看详情
    detailView(row, item) {
      if (typeof this.current.routerObj === 'string') {
        if (this.current.routerObj === 'tender-customize') {
          this.tenderView(row, item)
        }
        if (this.current.routerObj === 'inquiry-customize') {
          this.inquiryView(row, item)
        }
        if (this.current.routerObj === 'compete-customize') {
          this.competeView(row, item)
          return
        }
        if (this.current.routerObj === 'negotiate-customize') {
          this.negotiateView(row, item)
        }
        if (this.current.routerObj === 'entrustList-customize') {
          this.entrustView(row, item)
        }
        if (this.current.routerObj === 'supplier-negotiate-customize') {
          this.supplierNegotiateView(row, item)
        }
      } else {
        const routerObj = this.current.routerObj
        routerObj.params.orderId = item.orderId
        routerObj.params.tradeId = item.tradeId
        this.$router.replace(routerObj)
      }
    },
    // 查看招标详情
    tenderView(row, item) {
      const routerName = this.bidInviteBidStatusDict.translate(item.status)
        .routerName
      this.jumpPage({
        name: (this.isIdentity == 'purchaser' ? '' : 'Agency') + routerName,
        params: { orderId: item.orderId }
      })
    },

    // 查看询比详情
    inquiryView(row, item) {
      const tempRouterName = inquiryFlowStatusDict.translate(item.orderStatus)
        .routerName
      this.jumpPage({
        name: (this.isIdentity == 'purchaser' ? '' : 'Agency') + tempRouterName,
        params: { orderId: item.orderId, orderName: item.orderName }
      })
    },

    // 查看竞价详情
    competeView(row, item) {
      const routerName = competeStatusDict.translate(item.status).routerName
      this.jumpPage({
        name: (this.isIdentity == 'purchaser' ? '' : 'Agency') + routerName,
        params: { orderId: item.orderId }
      })
    },

    // 查看谈判详情
    negotiateView(row, item) {
      if (item.negotiateType === negotiateTypeDict.COMMON.value) {
        this.$router.push({
          name:
            (this.isIdentity == 'purchaser' ? '' : 'Agency') +
            negotiationV2StatusDict.translate(item.orderStatus)
              .routerCommonName,
          params: { orderId: item.orderId }
        })
      } else {
        this.$router.push({
          name: negotiationV2StatusDict.translate(item.orderStatus).routerName,
          params: { orderId: item.orderId }
        })
      }
    },

    // 查看委托详情
    entrustView(row, item) {
      const projectId = item.projectId
      this.jumpPage({ name: 'PurchaserEntrustDetail', params: { projectId } })
    },

    // 供应商分项谈判详情
    supplierNegotiateView(row, item) {
      let purchaseType = item.purchaseType
      if (purchaseType === purchaseAllTypeDict.NEGOTIATION_V2.value) {
        purchaseType = negotiateTypeDict.translate(item.negotiateType)
          .purchaseValue
      }
      this.jumpPage({
        name: purchaseAllTypeDict.translate(purchaseType).tradeRouterName,
        params: { orderId: item.orderId, tradeId: item.tradeId }
      })
    },

    // 跳转到响应列表
    goList(routerName) {
      this.$router.push({
        name: routerName
      })
    },

    /**
     * @description: 跳转页面
     * @param {*}
     * @return {*}
     */
    jumpPage(pageInfo) {
      this.$router.push(pageInfo)
    }
  }
}
</script>

<style scoped lang="scss">
.page-item {
  background: $white-color;
  margin: 16px 8px 16px 8px;
  box-sizing: border-box;
  padding-top: 24px;
  position: relative;
  .text {
    font-size: 16px;
    color: $second-text-color;
  }
  .active {
    color: $primary-color;
  }
  ::v-deep .el-menu {
    padding-left: 40px;
  }
  .content {
    height: 716px;
  }
  .scrollbar-y-hidden {
    &.el-scrollbar {
      .el-scrollbar__wrap {
        overflow-x: hidden !important;
      }
    }
  }
  .list-line {
    background: $info-fourth-color;
    height: 1px;
    width: 100%;
    margin-top: 12px;
  }
  .no-list-line {
    display: none;
  }
  .list-item {
    position: relative;
    padding: 0 24px;
    box-sizing: border-box;
    &:first-child {
      padding-top: 8px;
    }
    &:nth-child(6) {
      padding-bottom: 16px;
    }
    &:hover {
      background: $info-fifth-color;
      cursor: pointer;
      .item1 {
        .name-box {
          .name {
            color: $primary-color;
          }
        }
      }
    }
    .item1 {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-top: 16px;
      width: 100%;
      .name-box {
        width: calc(100% - 150px);
        display: flex;
        align-items: center;
        .name {
          font-size: 16px;
          color: $text-color;
          display: inline-block;
          max-width: calc(100% - 80px);
        }
        .text2 {
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2px 6px;
          font-size: 12px;
          background: $primary-color;
          color: $white-color;
          display: inline-block;
          border-radius: 2px;
          margin-top: -2px;
        }
      }
      .text3 {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 4px 12px;
        font-size: 12px;
        border-radius: 2px;
        color: $primary-color;
        background: $primary-fourth-color;
      }
    }
    .item2 {
      display: flex;
      font-size: 14px;
      color: $info-color;
      flex-wrap: wrap;
      margin-top: 4px;
      .text1 {
        width: 45%;
        line-height: 24px;
      }
      .text2 {
        line-height: 24px;
        width: 55%;
      }
      .text3 {
        line-height: 24px;
        width: 100%;
      }
      .text4 {
        color: $primary-color;
      }
    }
  }
}
.warning {
  color: $warning-color !important;
  background: $warning-third-color !important;
}
.success {
  color: $success-color !important;
  background: $success-third-color !important;
}
.primary {
  color: $primary-color !important;
  background: $primary-fourth-color !important;
}
.danger {
  color: $danger-color !important;
  background: $danger-third-color !important;
}
.info {
  color: $info-color !important;
  background: $info-fifth-color !important;
}
.hint-box {
  background: $info-sixth-color;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  height: 40px;
  display: flex;
  align-items: center;
  border: 1px solid $info-fourth-color;
  justify-content: center;
  color: $second-text-color;
  font-size: 14px;
}
</style>
